import { render, staticRenderFns } from "./StoreTransferCreate.vue?vue&type=template&id=58edfb03"
import script from "./StoreTransferCreate.vue?vue&type=script&lang=js"
export * from "./StoreTransferCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports